import React from 'react';
import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { SecondaryButton } from 'src/design/atoms/SecondaryButton';
import { DangerButton } from 'src/design/atoms/DangerButton';
import { BaseModal } from 'src/design/molecules/BaseModal';

export interface IRevokeLinksModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  revoking: boolean;
  /** The entity whose links are being revoked, e.g. "change" or "transmittal". */
  entityNoun: string;
  /** The attached items whose links stop working, e.g. "attachments" or "documents". */
  itemsNoun: string;
}

/**
 * @registry Confirmation dialog for revoking an entity's shared external attachment links. Owns the warning copy and the Cancel/Revoke buttons; the caller supplies open/close/confirm wiring (typically from useRevokeExternalLinks) plus the entity/items nouns that customise the copy.
 */
export const RevokeLinksModal: React.FC<IRevokeLinksModalProps> = ({
  opened,
  onClose,
  onConfirm,
  revoking,
  entityNoun,
  itemsNoun,
}) => (
  <BaseModal opened={opened} onClose={onClose} title="Revoke shared links">
    <Stack>
      <Text>
        Every link previously shared for this {entityNoun}&apos;s {itemsNoun}{' '}
        will stop working. Anyone who was sent a link will need a new one. This
        cannot be undone.
      </Text>
      <Group justify="flex-end">
        <SecondaryButton onClick={onClose} disabled={revoking}>
          Cancel
        </SecondaryButton>
        <DangerButton onClick={onConfirm} loading={revoking}>
          Revoke links
        </DangerButton>
      </Group>
    </Stack>
  </BaseModal>
);
